var _defs, _circle, _g, _path, _path2, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMemoriaRapidaPremium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 120",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "glow-lightning",
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "blur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "motion-blur",
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: "4 0",
    result: "blur"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "boltGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FEF08A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#F59E0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#EA580C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bgSpeed",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#1E3A8A",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0F172A",
    stopOpacity: 0
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 50,
    fill: "url(#bgSpeed)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#38BDF8",
    strokeWidth: 2,
    strokeLinecap: "round",
    opacity: 0.4,
    filter: "url(#motion-blur)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 20,
    x2: 40,
    y2: 40
  }), /*#__PURE__*/React.createElement("line", {
    x1: 90,
    y1: 10,
    x2: 70,
    y2: 30
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 80,
    x2: 30,
    y2: 70
  }), /*#__PURE__*/React.createElement("line", {
    x1: 105,
    y1: 90,
    x2: 80,
    y2: 75
  }), /*#__PURE__*/React.createElement("line", {
    x1: 110,
    y1: 50,
    x2: 85,
    y2: 55
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65,15 L35,65 L55,65 L45,105 L85,45 L60,45 Z",
    fill: "#FDE047",
    opacity: 0.3,
    filter: "url(#glow-lightning)",
    transform: "translate(4, 2)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65,15 L35,65 L55,65 L45,105 L85,45 L60,45 Z",
    fill: "url(#boltGrad)",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinejoin: "round",
    filter: "url(#glow-lightning)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 30,
    r: 3,
    fill: "#FFFFFF",
    filter: "url(#glow-lightning)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 80,
    r: 2,
    fill: "#FDE047",
    filter: "url(#glow-lightning)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 90,
    r: 4,
    fill: "#F59E0B",
    filter: "url(#glow-lightning)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 95,
    cy: 40,
    r: 2.5,
    fill: "#FFFFFF",
    filter: "url(#glow-lightning)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 35,
    fill: "none",
    stroke: "#FCD34D",
    strokeWidth: 1,
    opacity: 0.5,
    strokeDasharray: "10 5",
    transform: "rotate(45 60 60)"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 45,
    fill: "none",
    stroke: "#38BDF8",
    strokeWidth: 1,
    opacity: 0.3,
    strokeDasharray: "5 15",
    transform: "rotate(-30 60 60)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemoriaRapidaPremium);
export default __webpack_public_path__ + "static/media/memoria_rapida_premium.e85370d6361e5456458f1d11138be77c.svg";
export { ForwardRef as ReactComponent };